















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class BaseFooter extends Vue {
  /* ------------- Data -------------------- */
  /* ------------- Props ------------------- */
  /* ------------- Computed ---------------- */
  /* ------------- Methods ----------------- */
  /* ------------- Lifecycle Hooks --------- */
}
